export class LadingSchesule {
    id: number;
    shipmentId: number;
    incidentsId: number;
    location: string;
    note: string;
    dateCreated: string;
    timeCreated: string;
    hubId: number;
    hubName: string;
    userId: number;
    userFullName: string;
    userPhone: string;
    shipmentStatusId: number;
    shipmentStatusName: string;
    toUserCode: string;
    toUserFullname: string;
}